import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { SnackbarService } from 'src/app/core/services/snackbar.service';
import * as fromCore from 'src/app/core/store';
import {
  clearSharedMapUrl,
  createSharedMapAttempt
} from 'src/app/core/store/actions';
import { SharedMapRequest } from '../../models/shared-map-request';

@Component({
  selector: 'atlas-share-map-dialog',
  templateUrl: './share-map-dialog.component.html',
  styleUrls: ['./share-map-dialog.component.less'],
  standalone: false
})
export class ShareMapDialogComponent implements OnInit, OnDestroy {
  private subscription = new Subscription();

  titleControl = new FormControl('', {
    nonNullable: true,
    validators: [Validators.required, Validators.pattern(/\S/)]
  });

  shareMapUrl$ = this.store$.select(fromCore.getShareMapUrl);
  isSavingMap$ = this.store$.select(fromCore.getIsSavingMap);
  shareMapUrl = '';
  isCopying = false;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: SharedMapRequest,
    private store$: Store<fromCore.State>,
    private snackbarService: SnackbarService
  ) {}

  ngOnInit(): void {
    this.titleControl.setValue(this.data.mapTitle?.trim() ?? '');
    this.store$.dispatch(clearSharedMapUrl());
    this.subscription.add(
      this.shareMapUrl$.subscribe((shareMapUrl) => {
        this.shareMapUrl = shareMapUrl;
      })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  onSaveMapClicked() {
    if (!this.data.selectedFeature || this.titleControl.invalid) return;

    this.store$.dispatch(
      createSharedMapAttempt({
        request: this.getSharedMapRequest()
      })
    );
  }

  onCopyClicked() {
    if (this.isCopying || !this.shareMapUrl) return;

    this.isCopying = true;
    navigator.clipboard
      .writeText(this.shareMapUrl)
      .then(() => (this.isCopying = false))
      .catch(() => {
        this.isCopying = false;
        this.snackbarService.error(
          $localize`:@@shareMapCopyErrorHeader:Share Map`,
          $localize`:@@shareMapCopyErrorMessage:The shared map link could not be copied. Please copy it from the Map Link field.`
        );
      });
  }

  onLaunchMapClicked() {
    if (!this.shareMapUrl) return;

    window.open(this.shareMapUrl, '_blank');
  }

  private getSharedMapRequest(): SharedMapRequest {
    return {
      ...this.data,
      mapTitle: this.titleControl.value.trim()
    };
  }
}
